<template>
  <span>
    <span v-if="item.type === 'organic'">
      <span v-if="item.meta.pos0" class="mr-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">mdi-numeric-0-box</v-icon>
          </template>
          <span>{{ $t('link') }}</span>
        </v-tooltip>
      </span>

      <a :href="item.meta.link" style="text-decoration: none; white-space: nowrap; text-overflow: ellipsis;"
         target="_blank">
        <span v-if="parseUrl(item.meta.link).protocol === 'https:'" class="mr-1">
          <v-icon small color="success">mdi-lock</v-icon>
        </span>
        <span v-else class="mr-1"><v-icon small>mdi-lock</v-icon></span>
        <span class="black--text">{{ parseUrl(item.meta.link).host }}</span>
        <span v-if="$vuetify.breakpoint.mdAndUp">
          <span class="grey--text">{{ parseUrl(item.meta.link).pathname }}</span>
          <span class="grey--text">{{ parseUrl(item.meta.link).search }}</span>
          <span class="grey--text">{{ parseUrl(item.meta.link).hash }}</span>
        </span>
        -
        <span v-if="item.meta.small_site_links && item.meta.small_site_links.length > 0">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" style="font-size: 20px;" v-bind="attrs"
                      v-on="on">mdi-link-box-variant</v-icon>
            </template>
            <span>Mini site-links : {{ item.meta.small_site_links.map(link => link.title).join(', ') }}</span>
          </v-tooltip>
        </span>
        <span v-if="item.meta.site_links && item.meta.site_links.length > 0">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" style="font-size: 20px;" v-bind="attrs"
                      v-on="on">mdi-link-box-variant</v-icon>
            </template>
            <span>Site-links : {{ item.meta.site_links.map(link => link.title).join(', ') }}</span>
          </v-tooltip>
        </span>
        <span v-if="item.meta.notation">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" style="font-size: 20px;" v-bind="attrs" v-on="on">mdi-star-box</v-icon>
            </template>
            <span>{{ item.meta.notation }}</span>
          </v-tooltip>
        </span>
        <span v-if="item.meta.faq && item.meta.faq.length > 0">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" style="font-size: 20px;" v-bind="attrs" v-on="on">mdi-help-box</v-icon>
            </template>
            <span>{{ $t('faq') }}</span>
          </v-tooltip>
        </span>
        <span v-if="item.meta.p0">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" style="font-size: 20px;" v-bind="attrs"
                      v-on="on">mdi-numeric-0-box</v-icon>
            </template>
            <span>{{ $t('position') }}</span>
          </v-tooltip>
        </span>
      </a>
    </span>

    <span v-else-if="item.type === 'ads'">
      <a class="primary--text" target="_blank" :href="item.meta.link" style="text-decoration: none;">
        <v-icon small color="primary">mdi-google-ads</v-icon>
        <span style="font-weight: 500;"> {{ $t('google-ads') }} </span> -
        <span class="black--text">{{ parseUrl(item.meta.link).host }}</span>
        <span v-if="$vuetify.breakpoint.mdAndUp">
          <span class="grey--text">{{ parseUrl(item.meta.link).pathname }}</span>
          <span class="grey--text">{{ parseUrl(item.meta.link).search }}</span>
          <span class="grey--text">{{ parseUrl(item.meta.link).hash }}</span>
        </span>
      </a>
    </span>
    <span v-else-if="item.type === 'maps'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-google-maps</v-icon><span
        style="font-weight: 500;"> Google Maps </span>
      </span>
    </span>
    <span v-else-if="item.type === 'route_planner'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-road-variant</v-icon><span style="font-weight: 500;"> {{ $t('route-planner') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'videos'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-youtube</v-icon><span style="font-weight: 500;"> {{ $t('videos') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'images'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-image</v-icon><span style="font-weight: 500;"> {{ $t('images') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'news'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-newspaper</v-icon><span style="font-weight: 500;"> {{ $t('news') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'news_row'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-newspaper</v-icon><span style="font-weight: 500;"> {{ $t('news') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'news_brand'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-newspaper</v-icon><span style="font-weight: 500;"> {{ $t('news') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'news_box'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-newspaper</v-icon><span style="font-weight: 500;"> {{ $t('news') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'paa'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-comment-question</v-icon><span style="font-weight: 500;"> {{ $t('paa') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'search_on'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-magnify</v-icon><span style="font-weight: 500;"> {{ $t('search-on') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'ads_local_grid'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-cart</v-icon><span style="font-weight: 500;">{{ $t('ads-local-grid') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'ads_shop'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-cart</v-icon><span style="font-weight: 500;">{{ $t('ads-shop') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'discover_more_places'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-airplane-takeoff</v-icon><span style="font-weight: 500;">{{ $t('discover-more-places') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'hotels'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-bed</v-icon><span style="font-weight: 500;">{{ $t('hotels') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'flight'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-airplane</v-icon><span style="font-weight: 500;">{{ $t('flight') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'popular_destinations'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-airplane-takeoff</v-icon><span style="font-weight: 500;"> {{ $t('popular-destinations') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'sport_results'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-soccer</v-icon><span
        style="font-weight: 500;"> {{ $t('sport-results') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'sport_results_2'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-soccer</v-icon><span
        style="font-weight: 500;"> {{ $t('sport-results') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'twitter_card'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-twitter</v-icon><span style="font-weight: 500;"> {{ $t('twitter-card') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'weather'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-weather-partly-snowy-rainy</v-icon><span style="font-weight: 500;">{{ $t('weather') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'refine_search'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-clipboard-text-search</v-icon><span style="font-weight: 500;">{{ $t('refine-search') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'direct_answer'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-forum</v-icon><span
        style="font-weight: 500;">{{ $t('direct-answer') }}</span>
      </span>
    </span>
    <span v-else-if="item.type === 'direct_answer_hour'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-forum</v-icon><span
        style="font-weight: 500;"> {{ $t('direct-answer-hour') }}</span>
      </span>
    </span>
    <span v-else-if="item.type === 'direct_answer_review'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-forum</v-icon><span
        style="font-weight: 500;"> {{ $t('direct-answer-hour') }}</span>
      </span>
    </span>
    <span v-else-if="item.type === 'calculator'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-calculator-variant</v-icon><span style="font-weight: 500;"> {{ $t('calculator') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'calculator'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-calculator-variant</v-icon><span style="font-weight: 500;"> {{ $t('calculator') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'color_selector'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-palette</v-icon><span style="font-weight: 500;"> {{ $t('color-selector') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'graph'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-currency-usd</v-icon><span style="font-weight: 500;"> {{ $t('graph') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'unit_converter'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-speedometer</v-icon><span style="font-weight: 500;"> {{ $t('unit-converter') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'stocks'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-finance</v-icon><span style="font-weight: 500;"> {{ $t('stocks') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'currency_converter'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-currency-usd</v-icon><span style="font-weight: 500;"> {{ $t('currency-converter') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'recipes'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-chef-hat</v-icon><span style="font-weight: 500;"> {{ $t('recipes') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'movie'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-movie-open</v-icon><span
        style="font-weight: 500;"> {{ $t('movie') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'song'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-microphone-variant</v-icon><span
        style="font-weight: 500;"> {{ $t('carousel-song') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'carousel_movie'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-view-carousel-outline</v-icon><span
        style="font-weight: 500;"> {{ $t('carousel-movie') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'carousel_information'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-view-carousel-outline</v-icon><span style="font-weight: 500;"> {{ $t('carousel-movie') }}</span>
      </span>
    </span>
    <span v-else-if="item.type === 'carousel_information_2'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-view-carousel-outline</v-icon><span style="font-weight: 500;"> {{ $t('carousel-movie') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'carousel_information_3'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-view-carousel-outline</v-icon><span style="font-weight: 500;"> {{ $t('carousel-movie') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'translate'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-google-translate</v-icon><span style="font-weight: 500;"> {{ $t('translate') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'definition'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-book-open-variant</v-icon><span style="font-weight: 500;"> {{ $t('definition') }} </span>
      </span>
    </span>
    <span v-else-if="item.type === 'jobs'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-account-search</v-icon><span style="font-weight: 500;"> {{ $t('jobs') }}</span>
      </span>
    </span>
    <span v-else-if="item.type === 'covid_stat'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-needle</v-icon><span style="font-weight: 500;"> {{ $t('covid-stat') }}</span>
      </span>
    </span>
    <span v-else-if="item.type === 'knowledge_graph'">
      <span class="primary--text">
        <v-icon small color="primary">mdi-school</v-icon>
        <span style="font-weight: 500;"> {{ $t('knowledge-graph') }}</span>
      </span>
    </span>
    <span v-else-if="$account.isAdministrator">
      <span>
        <span class="primary--text" style="font-weight: 500;">
          <v-icon small color="primary">mdi-alert</v-icon>
          {{ $t('unknown-bloc') }}
        </span>
        <span>(Vous voyez ce bloc car vous êtes administrateur)</span><br/>
        <textarea v-html="item" style="width: 100%" rows="4"></textarea>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'SerpDialogDetailTableItems',
  props: ['item'],
  methods: {
    parseUrl (url) {
      try {
        return new URL(url)
      } catch (e) {
        return {
          protocol: '',
          host: '',
          pathname: '',
          search: '',
          hash: '',
        }
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"ads-local-grid": "Google Ads Local",
		"ads-shop": "Google Shopping",
		"calculator": "Google Application: Calculator",
		"carousel-movie": "Informational carousel",
		"carousel-song": "Song Carousel",
		"color-selector": "Google Application: Color Picker",
		"covid-stat": "COVID statistics",
		"currency-converter": "Google Finance: Currency converter",
		"definition": "Google Definition",
		"direct-answer": "Onebox Quick Response",
		"direct-answer-hour": "Onebox Quick Response",
		"discover-more-places": "Google Travel: Places to discover",
		"faq": "Frequently Asked Questions",
		"flight": "Google Flight",
		"google-ads": "Google Ads",
		"graph": "Google Application: Graphics",
		"hotels": "Google Hotel",
		"images": "Google Images",
		"jobs": "Google Careers: Jobs",
		"knowledge-graph": "Knowledge Graph",
		"link": "Link displayed in position 0",
		"movie": "Film Carousel",
		"news": "Google News",
		"paa": "People Also Ask (PAA)",
		"popular-destinations": "Popular destinations for Google Travel",
		"position": "Position 0",
		"recipes": "Receipts",
		"refine-search": "Refine the search",
		"route-planner": "Route planner",
		"search-on": "Search On",
		"sport-results": "Sports results",
		"stocks": "Google Finance: Stocks",
		"translate": "Google Translate",
		"twitter-card": "Twitter card",
		"unit-converter": "Google Application: Unit converter",
		"unknown-bloc": "Unknown block",
		"videos": "Google Videos",
		"weather": "Weather"
	},
	"es": {
		"ads-local-grid": "Anuncios locales de Google",
		"ads-shop": "Google Shopping",
		"calculator": "Aplicación de Google: Calculadora",
		"carousel-movie": "Carrusel informativo",
		"carousel-song": "carrusel de canciones",
		"color-selector": "Google Application: Selector de color",
		"covid-stat": "Estadísticas de COVID",
		"currency-converter": "Google Finance: Conversor de divisas",
		"definition": "Google definición",
		"direct-answer": "Respuesta rápida de Onebox",
		"direct-answer-hour": "Respuesta rápida de Onebox",
		"discover-more-places": "Google Viaje: Lugares por descubrir",
		"faq": "Preguntas frecuentes",
		"flight": "Vuelo de Google",
		"google-ads": "Anuncios de Google",
		"graph": "Google Aplicación: Gráficos",
		"hotels": "Google Hotel",
		"images": "Google Imágenes",
		"jobs": "Carreras de Google: Trabajos",
		"knowledge-graph": "Gráfico de conocimiento",
		"link": "Enlace mostrado en la posición 0",
		"movie": "Carrusel de películas",
		"news": "Noticias de Google",
		"paa": "La gente también pregunta (PAA)",
		"popular-destinations": "Destinos populares de Google Travel",
		"position": "Posición 0",
		"recipes": "Recetas",
		"refine-search": "Refinar busqueda",
		"route-planner": "Planeador de itinerario",
		"search-on": "Busca en",
		"sport-results": "Resultados deportivos",
		"stocks": "Google Finance: Acciones",
		"translate": "Traducción de Google",
		"twitter-card": "Tarjeta de Twitter",
		"unit-converter": "Aplicación de Google: Conversor de unidades",
		"unknown-bloc": "Bloque desconocido",
		"videos": "Vídeos de Google",
		"weather": "Reporte del clima"
	},
	"fr": {
		"ads-local-grid": "Google Ads locale",
		"ads-shop": "Google Shopping",
		"calculator": "Google Application : Calculatrice",
		"carousel-movie": "Carrousel informationnel",
		"carousel-song": "Carrousel de chansons",
		"color-selector": "Google Application : Sélecteur de couleur",
		"covid-stat": "Statistiques COVID",
		"currency-converter": "Google Finance : Convertisseur de devise",
		"definition": "Google Définition",
		"direct-answer": "Onebox Réponse Rapide",
		"direct-answer-hour": "Onebox Réponse Rapide",
		"discover-more-places": "Google Voyage : Lieux à découvrir",
		"faq": "Foire aux questions",
		"flight": "Google Vol",
		"google-ads": "Google Ads",
		"graph": "Google Application : Graphique",
		"hotels": "Google Hôtel",
		"images": "Google Images",
		"jobs": "Google Carrières : Offres d'emploi",
		"knowledge-graph": "Knowledge Graph",
		"link": "Lien affiché en position 0",
		"movie": "Carrousel de Film",
		"news": "Google News",
		"paa": "People Also Ask (PAA)",
		"popular-destinations": "Google Voyage : Destinations populaires",
		"position": "Position 0",
		"recipes": "Recettes",
		"refine-search": "Affiner la recherche",
		"route-planner": "Planificateur d'itinéraire",
		"search-on": "Search On",
		"sport-results": "Résultats sportifs",
		"stocks": "Google Finance : Actions",
		"translate": "Google Traduction",
		"twitter-card": "Carte Twitter",
		"unit-converter": "Google Application : Convertisseur d'unité",
		"unknown-bloc": "Bloc inconnu",
		"videos": "Google Videos",
		"weather": "Météo"
	},
	"it": {
		"ads-local-grid": "Google Ads Locale",
		"ads-shop": "Google Shopping",
		"calculator": "Applicazione Google: Calcolatrice",
		"carousel-movie": "Carosello informativo",
		"carousel-song": "Carosello di canzoni",
		"color-selector": "Applicazione Google: Selettore colore",
		"covid-stat": "Statistiche COVID",
		"currency-converter": "Google Finance: Convertitore di valuta",
		"definition": "Google Definizione",
		"direct-answer": "Onebox Risposta Rapida",
		"direct-answer-hour": "Onebox Risposta Rapida",
		"discover-more-places": "Google Viaggi: Luoghi da scoprire",
		"faq": "Domande frequenti",
		"flight": "Google Voli",
		"google-ads": "Google Ads",
		"graph": "Applicazione Google: Grafico",
		"hotels": "Google Hotel",
		"images": "Google Immagini",
		"jobs": "Google Carriere: Offerte di lavoro",
		"knowledge-graph": "Knowledge Graph",
		"link": "Link visualizzato in posizione 0",
		"movie": "Carosello di film",
		"news": "Google News",
		"paa": "Le persone chiedono anche (PAA)",
		"popular-destinations": "Google Viaggi: Destinazioni popolari",
		"position": "Posizione 0",
		"recipes": "Ricette",
		"refine-search": "Affina la ricerca",
		"route-planner": "Pianificatore itinerario",
		"search-on": "Cerca su",
		"sport-results": "Risultati sportivi",
		"stocks": "Google Finance: Azioni",
		"translate": "Google Traduttore",
		"twitter-card": "Scheda Twitter",
		"unit-converter": "Applicazione Google: Convertitore di unità",
		"unknown-bloc": "Blocco sconosciuto",
		"videos": "Google Video",
		"weather": "Meteo"
	},
	"pt": {
		"ads-local-grid": "Google Ads Local",
		"ads-shop": "Google Shopping",
		"calculator": "Aplicação Google: Calculadora",
		"carousel-movie": "Carrossel informativo",
		"carousel-song": "Carrossel de músicas",
		"color-selector": "Aplicação Google: Seletor de cores",
		"covid-stat": "Estatísticas COVID",
		"currency-converter": "Google Finance: Conversor de moeda",
		"definition": "Google Definição",
		"direct-answer": "Onebox Resposta Rápida",
		"direct-answer-hour": "Onebox Resposta Rápida",
		"discover-more-places": "Google Viagem: Lugares a descobrir",
		"faq": "Perguntas frequentes",
		"flight": "Google Voos",
		"google-ads": "Google Ads",
		"graph": "Aplicação Google: Gráfico",
		"hotels": "Google Hotel",
		"images": "Google Imagens",
		"jobs": "Google Carreiras: Empregos",
		"knowledge-graph": "Knowledge Graph",
		"link": "Ligação exibida na posição 0",
		"movie": "Carrossel de filmes",
		"news": "Google Notícias",
		"paa": "As pessoas também perguntam (PAA)",
		"popular-destinations": "Google Viagem: Destinos populares",
		"position": "Posição 0",
		"recipes": "Receitas",
		"refine-search": "Refinar pesquisa",
		"route-planner": "Planificador de itinerário",
		"search-on": "Pesquisar em",
		"sport-results": "Resultados desportivos",
		"stocks": "Google Finance: Ações",
		"translate": "Google Tradutor",
		"twitter-card": "Cartão Twitter",
		"unit-converter": "Aplicação Google: Conversor de unidades",
		"unknown-bloc": "Bloco desconhecido",
		"videos": "Google Vídeos",
		"weather": "Meteorologia"
	},
	"pl": {
		"ads-local-grid": "Google Ads Lokalne",
		"ads-shop": "Google Shopping",
		"calculator": "Aplikacja Google: Kalkulator",
		"carousel-movie": "Karuzela informacyjna",
		"carousel-song": "Karuzela piosenek",
		"color-selector": "Aplikacja Google: Wybór koloru",
		"covid-stat": "Statystyki COVID",
		"currency-converter": "Google Finance: Przelicznik walut",
		"definition": "Google Definicja",
		"direct-answer": "Onebox Szybka odpowiedź",
		"direct-answer-hour": "Onebox Szybka odpowiedź",
		"discover-more-places": "Google Travel: Miejsca do odkrycia",
		"faq": "Często zadawane pytania",
		"flight": "Google Loty",
		"google-ads": "Google Ads",
		"graph": "Aplikacja Google: Wykres",
		"hotels": "Google Hotel",
		"images": "Google Grafika",
		"jobs": "Google Kariera: Oferty pracy",
		"knowledge-graph": "Knowledge Graph",
		"link": "Link wyświetlany na pozycji 0",
		"movie": "Karuzela filmów",
		"news": "Google Aktualności",
		"paa": "Ludzie pytają też (PAA)",
		"popular-destinations": "Google Travel: Popularne destynacje",
		"position": "Pozycja 0",
		"recipes": "Przepisy",
		"refine-search": "Zawęź wyszukiwanie",
		"route-planner": "Planowanie trasy",
		"search-on": "Szukaj na",
		"sport-results": "Wyniki sportowe",
		"stocks": "Google Finance: Akcje",
		"translate": "Google Tłumacz",
		"twitter-card": "Karta Twitter",
		"unit-converter": "Aplikacja Google: Przelicznik jednostek",
		"unknown-bloc": "Nieznany blok",
		"videos": "Google Wideo",
		"weather": "Pogoda"
	}
}
</i18n>
